/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".tabs[_ngcontent-%COMP%]{border:1px solid #ccc;border-radius:4px;width:100%}.tab-headers[_ngcontent-%COMP%]{list-style:none;margin:0;padding:0;display:flex;border-bottom:1px solid #ccc;text-align:center}.tab-headers[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{padding:10px 20px;cursor:pointer}.tab-headers[_ngcontent-%COMP%]   li.active[_ngcontent-%COMP%]{background-color:#126ea9;color:#fff}.tab-content[_ngcontent-%COMP%]{padding:20px}\n/*# sourceMappingURL=tabs.component.css.map*/"];
export { styles as styles };
